import { Box, styled } from '@mui/system';
import { Stack, Skeleton } from '@mui/material';
import { useSelector } from 'react-redux';
import ItemList from 'app/components/ItemList';
import Icon from 'app/components/Icon';
import Avatar from 'app/components/Avatar';
import {useNavigate } from 'react-router-dom';

const NotifyItem = styled(Stack)(({ theme, border = 0, bcolor }) => ({
    borderBottom:`${border}px solid ${bcolor} !important`,
    borderRadius:border ? 0 : "2px",
    '& .pht':{ border:`1px solid ${bcolor}` },
}));

const Notifications = ({ spacing = 0 , border = 1, loading = false, items = null, bcolor="#ddd" }) => {
    
    const user = useSelector((store) => store.auth.user || {});
    const navigate = useNavigate();

    const open = (item) =>{
        let _user = item?.type !== "F" ? user : item?.user;
        let _url = `/user/${_user?.username}`;

        if( item?.type !== 'F' )
            _url += `/activity/${item?.data?.object_id}`;
        navigate(_url,{state: _user});
    }
    
    const renderSkeleton = (i) => {
        return <NotifyItem className="notify_item" direction="row" key={`nfits_${items ? 1 : 0}_${i}`} border={border} bcolor={bcolor}>
            <div className="pht"><Skeleton height={40} variant="circular" width={40} /></div>
            <div className="dtl">
                <p style={{ display: 'flex', gap: '5px', marginBottom: '6px' }}>
                    <Skeleton height={14} style={{ borderRadius:"5px" }} variant="rounded" width={border ? 40 : 50} />
                    <Skeleton height={14} style={{ borderRadius:"5px" }} variant="rounded" width={border ? 120 : 170} />
                </p>
                <div className="tm">
                    <Skeleton height={14} style={{ borderRadius:"5px" }} variant="rounded" width={14} />
                    <Skeleton height={11} style={{ borderRadius:"5px" }} variant="rounded" width={70} />
                </div>
            </div>
        </NotifyItem>
    } 

    const renderItem = (item, idx, buttons) =>{
        let _user = item?.user || {};
        if( !_user.ID || !item.label)
            return null;

        return (
            <NotifyItem direction="row" className="notify_item" key={`nfitm_${items ? 1 : 0}_${idx}`} border={border} bcolor={bcolor}>
                <div className="pht">
                    <Avatar size="40px" name={`${_user.firstname} ${_user.lastname}`} url={_user.image} onClick={()=>navigate(`/user/${_user.username}`,{ state:_user})} />
                </div>
                <div className="dtl">
                    <p>
                        <a href={`/user/${_user.username}`} onClick={(e)=>{ e.preventDefault(); navigate(`/user/${_user.username}`,{ state:_user}); }}>{_user.firstname}</a> 
                        <span onClick={(e)=>open(item)}>{item.label}</span>
                        
                        {item?.with?.ID && (item?.with?.ID === _user?.ID ? <b>&nbsp;{item?.with?.gender === 'F' ? 'her' : 'him'}</b>  : <a className="a" href={`/user/${item.with.username}`} onClick={(e)=>{ e.preventDefault(); navigate(`/user/${item.with.username}`,{ state:item.with}); }}>{item.with.firstname}</a>)}
                    </p>
                    {item?.data?.comment && <p className="bld" onClick={(e)=>open(item)}>" {item?.data?.comment} "</p>}

                    {/*
                    {item?.with && (item?.with.ID == _user.ID )
                        ? <span>{_user.gender == 'F' ? 'her' : 'him'}</span> 
                        : <a onClick={()=>navigate("User",{ state:item?.with})}>
                      <b>{item?.with?.firstname}</b> 
                    </a>}
                    */}
                    <div className="tm">
                        <Icon>clock</Icon>
                        <span>{item.time} ago</span>
                    </div>
                </div>
                
            </NotifyItem>
        ) 
    }

    if( items ){
        return <Box style={loading ? { flex:1, overflow:"hidden", height:"100%" } : null}>
            {loading ? [0,1,2,3,4,5,6,7,8,9].map(itm=>renderSkeleton(itm)) : items.map((itm,idx)=>renderItem(itm,idx))}
        </Box>
    }

    return (
        <ItemList 
            url={`user/notifications/${user?.ID}`}
            heading="Notifications"
            headingIcon="bell"
            stickyHeader={true}
            emptyText="You have no notification yet" 
            searchBox={false}
            counter="notifications"
            errorMargin={20}
            columns={1} 
            spacing={`${spacing}px`}
            boxPadding="0px"
            limit={20} 
            skeleton={(item,i)=>renderSkeleton(i)}
            renderItem={renderItem}
            buttons={[{ icon: "times", key:"ID", url:"user/action/unfriend/[KEY]",  method:"POST", remove: true }]} 
        />
    );

};

export default Notifications;
